import MailIcon from "../../Components/ContactGetter/MailIconSvg";
import PhoneIcon from "../../Components/ContactGetter/PhoneIconSvg";
import { IContact } from "../../Interfaces/IContacts";

import "./ContactDetails.css";

interface ContactDetailsProps {
  Contact: IContact;
  SiteStartNumber: String;
}

function ContactDetails({ Contact, SiteStartNumber }: ContactDetailsProps) {
  const { Name, Phone, Mail } = Contact;
  return (
    <>
      <div>
        <h2 className="titleDetail">{Name}</h2>
        {Phone && (
          <div className="containerDetail">
            Appeler le{" "}
            <a
              href={`tel:${
                Phone.length < 10 ? `${SiteStartNumber}${Phone}` : Phone
              }`}
            >
              <span>
                <PhoneIcon />
                {Phone}
              </span>
            </a>
          </div>
        )}
        {Mail && (
          <div className="containerDetail">
            Ecrire à{" "}
            <a href={`mailto:${Mail}`}>
              <span>
                <MailIcon />
                {Mail}
              </span>
            </a>
          </div>
        )}
      </div>
    </>
  );
}

export default ContactDetails;
